module.exports = __webpack_public_path__ + "static/img/1051.43a4fe1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1051.jpg
// module id = 233
// module chunks = 0